import React, { useEffect } from 'react'
import QuestionComponentProps from '../../Questions/question-component-props'
import { fireReactGAEvent } from '../Questions/utils'
import { AppFormEventParams } from '../../services/events-service'
import { useAppFormEventsService } from '../../hooks/useAppFormEventsService'
import { AmplitudeEvents, trackAmplitudeEvent } from '../../utils/amplitude-utils'
import { toSnakeCase } from '../../utils/string-utils'

type WithQuestionExtraProps = {
  eventsServiceUrl?: string
  appFormEventParams?: AppFormEventParams
}

const withQuestion =
  <P extends QuestionComponentProps & WithQuestionExtraProps>(WrappedComponent: React.ComponentType<P>) =>
  (props: QuestionComponentProps & WithQuestionExtraProps): JSX.Element => {
    const { eventsServiceUrl, appFormEventParams, ...rest } = props
    const eventsService = useAppFormEventsService(eventsServiceUrl, appFormEventParams)

    useEffect(() => {
      const label = `qst.${props.questionKey}`
      fireReactGAEvent({
        category: 'Application Form',
        action: 'Question Visible',
        label,
        nonInteraction: true
      })
      eventsService?.sendEvent('AppFormQuestionVisible', { QuestionLabel: label })
      trackAmplitudeEvent(AmplitudeEvents.ApplicationQuestionViewed, { question_label: toSnakeCase(label) })
    }, [eventsService, props.questionKey])

    useEffect(() => {
      window.scrollTo(0, 0)
    }, [])

    return <WrappedComponent {...({ ...rest, eventsServiceUrl, appFormEventParams } as P)} />
  }

export default withQuestion
